import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/logout.svg'
import _imports_1 from '../assets/ms-symbollockup_signin_light.svg'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = {
  key: 0,
  class: "mainmenu"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Overview")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "header-splitter" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Logout ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loggedIn)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_2, [
          _createVNode(_component_router_link, {
            to: "/overview",
            class: "mainmenu-item",
            id: "header-overview"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _hoisted_4,
          _createVNode(_component_router_link, {
            to: "/logout",
            id: "header-logout",
            class: "keep-dark"
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _hoisted_6
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          to: "/login",
          id: "header-login"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }))
  ]))
}